import { useState, useEffect } from 'react';
import type { Account } from '@chikara/types';

interface UseAccountsReturn {
  accounts: Account[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useAccounts(): UseAccountsReturn {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchAccounts = async () => {
    setIsLoading(true);
    setError(null);

    try {
      // Demo data - in production this would call the API
      await new Promise(resolve => setTimeout(resolve, 500));
      setAccounts([
        {
          id: '1',
          userUuid: '1',
          type: 'checking',
          alias: 'cuenta.principal',
          cbu: '0000000000000000000001',
          currency: 'ARS',
          balance: {
            disposable: 125000.50,
            pending: 0,
            total: 125000.50,
          },
          isActive: true,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
        {
          id: '2',
          userUuid: '1',
          type: 'savings',
          alias: 'ahorros.mxn',
          cbu: '0000000000000000000002',
          currency: 'MXN',
          balance: {
            disposable: 2500.00,
            pending: 0,
            total: 2500.00,
          },
          isActive: true,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
      ]);
    } catch {
      setError('Error al cargar las cuentas');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  return {
    accounts,
    isLoading,
    error,
    refetch: fetchAccounts,
  };
}
